module.exports = __webpack_public_path__ + "static/media/snake-1.35da7fdf.jpg";